import { Card } from "@/components/ui/card";
import { Clock, CheckCircle2, AlertCircle } from "lucide-react";

interface RecentActivityProps {
  subscriptions?: any[];
}

export const RecentActivity = ({ subscriptions }: RecentActivityProps) => {
  return (
    <Card className="p-4 md:p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-medium">Recent Activity</h3>
        <Clock className="h-5 w-5 text-muted-foreground" />
      </div>
      <div className="space-y-4">
        {subscriptions?.slice(0, 5).map((sub) => (
          <div
            key={sub.id}
            className="flex flex-col sm:flex-row sm:items-center justify-between p-4 bg-muted/50 rounded-lg hover:bg-muted transition-all duration-200 gap-2 sm:gap-3"
          >
            <div className="flex items-center gap-3">
              {sub.payment_status === "completed" ? (
                <CheckCircle2 className="h-5 w-5 text-green-500 shrink-0" />
              ) : (
                <AlertCircle className="h-5 w-5 text-yellow-500 shrink-0" />
              )}
              <div>
                <p className="font-medium">{sub.plan_name}</p>
                <p className="text-sm text-muted-foreground">
                  {new Date(sub.created_at || "").toLocaleDateString()}
                </p>
              </div>
            </div>
            <div className="text-left sm:text-right">
              <p className="font-medium">${sub.price}</p>
              <p
                className={`text-sm ${
                  sub.payment_status === "completed"
                    ? "text-green-600 dark:text-green-400"
                    : "text-yellow-600 dark:text-yellow-400"
                }`}
              >
                {sub.payment_status}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};